import styled, { useTheme } from 'styled-components';
import Column from '../core/components/box/column';
import SizedBox from '../core/components/box/sizedBox';
import { device, useMedia } from '../core/designSystem/device';
import { LXh2, LXh1, LXh5, LXbody, LXbodyLong } from '../core/texts/lxText';

const NoticeContainer = styled.div`
  width: 100%;
  background-color: ${(props) => props.theme.colors.noticeBg};
`;
const NoticeBoxes = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 1040px;
  padding: 0 25px;
  @media ${device.tabletAndBelow} {
    flex-direction: column;
  }
`;
const NoticeBox = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  background-color: ${(props) => props.theme.colors.white};
  padding: 30px;
  width: 100%;
  align-items: center;
  @media ${device.desktop} {
    max-width: 336px;
    height: 240px;
  }
`;
const notices = [
  {
    category: 'Category',
    contents:
      'Providing the most advanced and fastest clinical laboratory services',
  },
  {
    category: 'Category',
    contents:
      'We are dedicated to become the world class healthcare partner by providing the fast and advanced healthcare solution',
  },
  {
    category: 'Category',
    contents:
      'Providing the most advanced and fastest clinical laboratory services',
  },
];

interface NoticeProps {}
const Notice = (props: NoticeProps) => {
  const { isTabletAndBelow, isDesktop } = useMedia();
  const theme = useTheme();
  const Title = () => {
    if (isTabletAndBelow) return <LXh2>{theme.intro.notice}</LXh2>;
    else return <LXh1>{theme.intro.notice}</LXh1>;
  };
  const SeeAll = () => {
    return (
      <button
        disabled
        style={{
          position: 'absolute',
          right: '25px',
          top: `${isDesktop ? '-64px' : '-52px'}`,
          backgroundColor: 'transparent',
          border: 'none',
        }}
        onClick={() => {}}
      >
        <LXh5 color={theme.colors.primary500}>{theme.texts.seeAll}</LXh5>
      </button>
    );
  };

  const NoticeUnit = ({
    category,
    contents,
    navigate = () => {},
  }: {
    category: string;
    contents: string;
    navigate?: () => void;
  }) => {
    return (
      <NoticeBox>
        <LXbody alignSelf="flex-start" color={theme.colors.caption}>
          {category}
        </LXbody>
        <SizedBox height={8} />
        <LXbodyLong
          fontSize="16px"
          lineHeight="21px"
          color={theme.colors.title}
        >
          {contents}
        </LXbodyLong>
        <SizedBox height={30} />
        <button
          disabled
          onClick={navigate}
          style={{
            position: `${isDesktop ? 'absolute' : 'relative'}`,
            bottom: `${isDesktop ? '30px' : '0px'}`,
            backgroundColor: 'transparent',
            border: 'none',
          }}
        >
          <LXbody color={theme.colors.primary500} fontSize='13px'>
            {theme.intro.learnMore}
          </LXbody>
        </button>
      </NoticeBox>
    );
  };
  return (
    <NoticeContainer>
      <Column width="100%" alignItems="center">
        <SizedBox height={isDesktop ? 80 : 60} />
        <Title />
        <SizedBox height={isDesktop ? 40 : 30} />
        <NoticeBoxes>
          <SeeAll />
          <NoticeUnit
            category={notices[0].category}
            contents={notices[0].contents}
          />
          <SizedBox width={16} height={16} />
          <NoticeUnit
            category={notices[1].category}
            contents={notices[1].contents}
          />
          <SizedBox width={16} height={16} />
          <NoticeUnit
            category={notices[2].category}
            contents={notices[2].contents}
          />
        </NoticeBoxes>
        <SizedBox height={isDesktop ? 100 : 80} />
      </Column>
    </NoticeContainer>
  );
};

export default Notice;
